/*
export function someMutation (state) {
}
*/


export function SET_CARTORIO(state, obj) {
  state.cartorio = obj.data;
}
